var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "aiBot"
  }, [_c('div', {
    attrs: {
      "id": "aiBotBox"
    }
  }), _c('div', {
    staticClass: "aiTextBox"
  }, [!_vm.State.aiBotCommandStatus ? _c('div', {
    staticClass: "defaultSpeechBar"
  }, [_c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "bar"
  })]) : _c('speechBarAnimation'), _vm.State.aiBotCommandStatus == 5 ? _c('span', [_vm._v(_vm._s(_vm.State.currentSpeech))]) : _c('span', {
    class: {
      grayColor: !_vm.State.aiBotCommandStatus
    }
  }, [_vm.State.aiBotCommandStatus == 4 ? _c('span', [_vm.State.partyJoinInfo && _vm.State.partyJoinInfo.owner ? _c('span', [_vm._v(" " + _vm._s(_vm.$t(`voiceCommand.${_vm.textByStatus[_vm.State.aiBotCommandStatus]}`)) + " "), _vm.State.aiBotCommandStatus === 4 ? _c('a', {
    staticClass: "setting",
    on: {
      "click": _vm.showParticipantSetting
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('setting.settingName')) + " ")]) : _vm._e()]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t('voiceCommand.participantNoProductId')) + " ")])]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t(`voiceCommand.${_vm.textByStatus[_vm.State.aiBotCommandStatus]}`)) + " ")])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };